class themeCartToggle {
	constructor() {
		this.wooMenuCart();
	}

	wooMenuCart() {
		let menuObject = document.getElementById('header__cart-toggle');
		let siteOverlay = document.getElementById('site-overlay');
		let sideNav = document.getElementById('site-nav--cart');
		let sideNavClose = document.getElementById('site-close-handle');
		if (
			null === menuObject ||
			null === siteOverlay ||
			null === sideNavClose
		) {
			return;
		}

		document.body.classList.add('has-woo-cart-slideout');

		menuObject.addEventListener('click', function (event) {
			event.preventDefault();
			toggleSideNavVisibility();
		});

		siteOverlay.addEventListener( 'click', function( event ) {
			toggleSideNavVisibility();
		} );
		sideNavClose.addEventListener( 'click', function( event ) {
			toggleSideNavVisibility();
		} );

		const toggleSideNavVisibility = (event) => {
			sideNav.classList.toggle('active');
			siteOverlay.classList.toggle('active');
			document.body.classList.toggle('sidebar-move');
		};
	}
}

jQuery(document).ready(function ($) {
	new themeCartToggle();
});
